import { render } from "./StudentView.vue?vue&type=template&id=6a51c788"
import script from "./StudentView.vue?vue&type=script&lang=js"
export * from "./StudentView.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__